module.exports = "/static/assets/551aae506dfa65ce3b45713b5300a678.svg";